module.exports = __webpack_public_path__ + "img/parachute.eb6d30cc.svg";